<template>
  <div>
    <v-layout row style="margin: 18px;">
      <v-flex md6 ma-2 d-flex color="primary" style="height:404px;">
        <app-add-course-category ref="UpdateCourseCategory"></app-add-course-category>
      </v-flex>
      <v-flex md6 ma-2 d-flex color="primary" style="height:404px;">
        <course-category-table @UpdateCourseCategory="UpdateCourseCategory"></course-category-table>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import appAddCourseCategory from "../views/dialogs/AddCourseCategory";
import CourseCategoryTable from "../views/tables/CourseCategoryTable";

export default {
  components: {
    appAddCourseCategory,
    CourseCategoryTable
  },
  data() {
    return {};
  },
  methods: {
    UpdateCourseCategory(Details) {
      this.$refs.UpdateCourseCategory.OpenToUpdate(Details);
    }
  },
  mounted(){
    this.$eventHub.$emit("LOADING",'false')
  }
};
</script>
<style scoped>
</style>